import styled from "styled-components";
export const Wrapper = styled.div`
  .timespan {
    background-color: ${({ theme }) => theme.box};
    padding: 10px 0px !important;
    border-radius: 5px;
    margin: 0px;
    margin-top: 10px;
  }
  .user-wrapper {
    background-color: ${({ theme }) => theme.box};
  }
  .user-card {
    box-shadow: 0px 3px 10px #00000010;
    padding: 10px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.box};
  }
  .filterButtons {
    .button {
      text-align: center;
      border-radius: 5px;
      padding: 20px 10px;
      &:hover {
        cursor: pointer;
      }
    }
    .button-inprogress {
      border: 1px solid #ffc107;
    }
    .button-failed {
      border: 1px solid #dc3847;
    }
    .button-success-offline {
      border: 1px solid #17a2b8;
    }
    .button-success-online {
      border: 1px solid #27a644;
    }
    .button-all-orders {
      border: 1px solid #027bff;
    }
  }
`;
